import React from 'react';
import { Box, Chip, Grid, createStyles, makeStyles } from '@material-ui/core';
import { Stack } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import Typography from '../../../atoms/typography';
import ButtonComponent from '../../../atoms/button';
import ProgressBar from '../../../atoms/progressBar';
import PublishedFreightTable from '../../../../modules/freight/PublishedFreightTable';
import commons from '../../../../assets/styles/commons';
import colors from '../../../../assets/styles/colors';
import { ReactComponent as ExclamationIcon } from '../../../../assets/icons/icon-exclamation.svg';
import history from '../../../../services/history';
import { freightTypeEnum } from '../../../../hooks/freights/useConfigureFreight';

const useStyles = makeStyles(() =>
  createStyles({
    box: {
      padding: 16,
      border: '1px solid #E4E9F2',
      borderRadius: 4,
      flex: 1,
    },
    chip: {
      marginTop: 10,
      backgroundColor: colors.secondary.lightBlue,
      color: colors.secondary.intenseNavy,
      border: '1px solid #8F9BB3',
      borderRadius: '4px',
      fontFamily: commons.fontFamily,
      fontSize: 14,
      flex: 1,
      display: 'flex',
      justifyContent: 'flex-start',
      fontVariant: 'lining-nums',
    },
  }),
);

interface PublishFreightProps {
  isLoading?: boolean;
  publishFreight?: boolean;
  setPublishFreight?: React.Dispatch<React.SetStateAction<boolean>>;
}

const PublishFreight: React.FC<PublishFreightProps> = ({
  publishFreight,
  isLoading,
}) => {
  const { getValues } = useFormContext();
  const classes = useStyles();

  const handleRedirect = () => {
    history.push('/home/shippings');
  };

  const handleNewImport = () => {
    window.location.reload();
  };

  const freightDetails = getValues();

  let freightInfos = [
    'Total de entregas',
    'Tipo de veículo',
    'Peso total',
    'Custo do frete',
  ];

  if (freightDetails.freightType === freightTypeEnum.INTERNAL) {
    freightInfos = freightInfos.filter(
      fieldName => fieldName !== 'Custo do frete',
    );
  }

  return (
    <Box component="div">
      {!publishFreight ? (
        <>
          <Typography fontWeight="700" color="primary">
            Publicar frete
          </Typography>
          <Chip
            label="Estamos publicando seus fretes. Aguarde um momento."
            icon={<ExclamationIcon />}
            className={classes.chip}
          />
          <Stack direction="row" spacing={2} style={{ marginTop: 15 }}>
            {freightInfos.map((label, index) => (
              <Box key={index} component="div" className={classes.box}>
                <Typography
                  fontWeight="400"
                  color="secondary"
                  textAlign="center"
                >
                  {label}
                </Typography>
                <Typography
                  fontWeight="700"
                  color="primary"
                  textAlign="center"
                  mt={3}
                >
                  {index === 0 && freightDetails.totalDeliveries}
                  {index === 1 && (freightDetails.vehicleType || '--')}
                  {index === 2 && `${freightDetails.totalWeight} Kg`}
                  {index === 3 &&
                    `R$ ${Number(freightDetails.freightCost).toLocaleString(
                      'pt-BR',
                      { minimumFractionDigits: 2, maximumFractionDigits: 2 },
                    )}`}
                </Typography>
              </Box>
            ))}
          </Stack>
          <Box component="div" marginTop={3}>
            <PublishedFreightTable />
          </Box>
          {isLoading && (
            <>
              <ProgressBar />
            </>
          )}
        </>
      ) : (
        <>
          <Typography fontWeight="700" color="primary">
            Pronto! Frete publicado
          </Typography>
          <Typography fontWeight="400" color="secondary" mt={4} mb={4}>
            Finalizamos a importação, o frete já está publicado e disponível
            para os motoristas da plataforma.
          </Typography>
          <Box component="div" marginTop={3}>
            <PublishedFreightTable />
          </Box>
          <Grid
            container
            justifyContent="space-between"
            style={{ marginTop: 30 }}
          >
            <ButtonComponent
              theme="outline-primary"
              justifyContent="flex-start"
              onClick={handleRedirect}
            >
              Conferir fretes
            </ButtonComponent>
            <ButtonComponent
              theme="primary"
              justifyContent="flex-end"
              onClick={handleNewImport}
            >
              Nova importação
            </ButtonComponent>
          </Grid>
        </>
      )}
    </Box>
  );
};

export default PublishFreight;
